import { render } from "./OtpForm.html?vue&type=template&id=1c7bc132&scoped=true&external"
import script from "./OtpForm.js?vue&type=script&lang=js&external"
export * from "./OtpForm.js?vue&type=script&lang=js&external"

import "./OtpForm.css?vue&type=style&index=0&id=1c7bc132&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7bc132"]])

export default __exports__